<template>
    <div class="m-panel">
        <div style="height: 100%;width: 100%" ref="map"></div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
//import 'echarts/extension/bmap/bmap'
import '@/assets/bmapGL/bmap';
var sxmap =  require("@/assets/mock/baoding.json");
var shangluo =  require("@/assets/mock/shangluo.json");
import configService from '@/utils/service/config.service'
import { postAction,getAction } from '@/api/manage'
import { mapGetters } from 'vuex'

var timer = null
var index = -1;
export default {
    data() {
        return {
            option: {},
            customMapStyle: require("@/assets/customMapStyle/custom_map_config.json"),
            chart: echarts.ECharts,
            bmap: {},
            url: {
                queryMetersByPointer: '/jeecg-charge/meter/meterUserinfo/queryMeterInfoByLngAndLat',
                queryMeterAddrInfoByOrgCode: '/jeecg-charge/meter/meterUserinfo/queryMeterAddrInfoByOrgCode'
            },
            meterList: []
        }
    },
    mounted() {
        this.queryMeterAddrInfoByOrgCode()
        
    },
    methods: {
        ...mapGetters(["userInfo"]),
        queryMeterAddrInfoByOrgCode() {
            this.meterList = []
            // 查看单位所安装表的坐标信息
            getAction(this.url.queryMeterAddrInfoByOrgCode,{}).then((res)=> {
                if(res.success) {
                    for(let i = 0;i<res.result.length;i++) {
                        let data = res.result[i]
                        let value = [data.userMeterLng,data.userMeterLat]
                        this.meterList.push({name: data.userMeterAddr,meterId: data.meterId,userId: data.userId,userPhone: data.userPhone,userMeterAddr: data.userMeterAddr,meterStatus: '正常',value: value})
                    }
                    this.$nextTick(() => {
                        this.createMap()
                    })
                }
            })
        },
        createMap() {
            let city = '保定市';
            let center = [114.967139,39.001176];
            let coordinateArr = [[115.154009,38.707448],[114.984507,38.761473],[114.993705,39.099178],[115.674405,39.020286],[115.485712,38.95989],[115.542054,38.875449],[115.799616,39.346659],[114.744071,38.673818],[114.304836,38.843082],[114.990135,39.489362]];
            if(this.userInfo().orgCode === 'A29') {
                city = '和静县'
                center = [86.391067,42.31716]
                data = this.meterList
            }else if(configService.backType == 1) {
                city = '商洛市'
                coordinateArr = [[109.111249,33.682773],[110.145716,34.088502],[110.33191,33.694711],[110.885437,33.526367],[110.653665,33.346962],[109.880435,33.530411],[109.990435,33.530411],[109.937685,33.869208],[109.151075,33.423981],[]];
                center = [109.929014,33.881271]
            }
            this.chart = echarts.init(this.$refs.map)
            let data = [
                {name: "管网压力1号",meterId: '000020210111',userMeterAddr: '演示位置1',pressValue: 1.3,meterType: '压力表',meterStatus: '正常',value: coordinateArr[0]},
                {name: "液位计1号",meterId: '000020210112',userMeterAddr: '演示位置2',pressValue: 2.4,meterType: '液位计',meterStatus: '正常',value: coordinateArr[1]},
                {name: "NB水表1",meterId: '000020210113',userName: 'NB水表1',userPhone: '13200000001',meterType: '水表',userMeterAddr: '演示位置3',meterStatus: '欠压',value: coordinateArr[2]},
                {name: "NB水表2",meterId: '000020210114',userName: 'NB水表2',userPhone: '13200000002',meterType: '水表',userMeterAddr: '演示位置4',meterStatus: '磁干扰',value:coordinateArr[3] },
                {name: "NB水表3",meterId: '000020210115',userName: 'NB水表3',userPhone: '13200000003',meterType: '水表',userMeterAddr: '演示位置5',meterStatus: '正常',value: coordinateArr[4]},
                {name: "NB水表4",meterId: '000020210116',userName: 'NB水表4',userPhone: '13200000004',meterType: '水表',userMeterAddr: '演示位置6',meterStatus: '正常',value: coordinateArr[5]},
                {name: "NB水表5",meterId: '000020210117',userName: 'NB水表5',userPhone: '13200000005',meterType: '水表',userMeterAddr: '演示位置7',meterStatus: '正常',value: coordinateArr[6]},
                {name: "NB水表6",meterId: '000020210118',userName: 'NB水表6',userPhone: '13200000006',userName: 'NB水表6',userPhone: '13200000006',meterType: '水表',userMeterAddr: '演示位置8',meterStatus: '正常',value: coordinateArr[7]},
                {name: "NB水表7",meterId: '000020210119',userName: 'NB水表7',userPhone: '13200000007',meterType: '水表',userMeterAddr: '演示位置9',meterStatus: '正常',value: coordinateArr[8]},
                {name: "NB水表8",meterId: '000020210120',userName: 'NB水表8',userPhone: '13200000008',meterType: '水表',userMeterAddr: '演示位置10',meterStatus: '正常',value: coordinateArr[9]},
            ]
            if(this.userInfo().orgCode === 'A29') {
                data = this.meterList
            }

            let that = this
            let option = {
                bmap: {
                    center: center,
                    zoom: 10,
                    roam: true,
                    mapStyle: {
                        styleJson: this.customMapStyle
                    }
                },
                tooltip: {
                    // trigger: 'item'
                    show: false,
                    trigger: 'item',
                    backgroundColor: 'rgba(2, 31, 95, 0.82)',
                    borderColor: '#FFFFCC',
                    showDelay: 0,
                    padding: 10,
                    hideDelay: 0,
                    enterable: true,
                    transitionDuration: 0,
                    extraCssText: 'z-index:100',
                    formatter: (params, ticket, callback) => {

                        /*
                        //根据业务自己拓展要显示的内容
                        if (params.seriesType == "effectScatter") {
                            if(params.data.meterType == '压力表') {
                                return "安装位置：" + params.data.userMeterAddr +
                                '<br/>设备编号：' + params.data.meterId +
                                '<br/>设备类型：' + params.data.meterType +
                                '<br/>当前压力值：' + params.data.pressValue +'Mpa'+
                                '<br/>运行状态：' + params.data.meterStatus +
                                '<br/>'
                            }else if(params.data.meterType == '液位计') {
                                return "安装位置：" + params.data.userMeterAddr +
                                '<br/>设备编号：' + params.data.meterId +
                                '<br/>设备类型：' + params.data.meterType +
                                '<br/>当前液位：' + params.data.pressValue + 'm'+
                                '<br/>运行状态：' + params.data.meterStatus +
                                '<br/>'
                            }
                            return "安装位置：" + params.data.userMeterAddr +
                                '<br/>设备编号：' + params.data.meterId +
                                '<br/>设备类型：' + params.data.meterType +
                                '<br/>用户姓名：' + params.data.userName +
                                '<br/>联系电话：' + params.data.userPhone +
                                '<br/>运行状态：' + params.data.meterStatus +
                                '<br/>'
                        }
                        */
                       let str = '<div><table border="1">'
                       str+='<tr><th>'+this.$t('设备编号')+'</th><th>'+this.$t('用户姓名')+'</th><th>'+this.$t('联系电话')+'</th><th>'+this.$t('安装位置')+'</th><th>'+this.$t('阀门状态')+'</th><th>'+this.$t('运行状态')+'</th></tr>'
                       getAction(that.url.queryMetersByPointer, {lng: params.value[0],lat: params.value[1]}).then((res) => {
                           if(res.success&&res.result.length>0) {
                               for(let i =0;i<res.result.length;i++) {
                                   let data = res.result[i]
                                   let status = this.$t('正常')
                                   if(data.meterBatteryStatus!==0) {
                                       status = this.$t('欠压')
                                   }
                                   if(data.meterBatteryStatus!==0) {
                                       status+=this.$t('有磁干扰')
                                   }
                                   let valveStatusObj = {0: this.$t('关阀'),1: this.$t('开阀')}
                                    str+=`<tr><td>${data.meterId}</td><td>${data.userName}</td><td>${data.userPhone}</td><td>${data.userMeterAddr}</td><td>${valveStatusObj[data.meterValveStatus]}</td><td>${status}</td>`
                                    str+=`</tr>`
                               }
                           }
                           str+='</table></div>'
                           console.log(str)
                          callback(ticket, str);
                       })
                       return 'loading'
                    }
                },
                series: [
                    {
                        name: 'Top 5',
                        type: 'effectScatter',
                        coordinateSystem: 'bmap',
                        data: data,
                        encode: {
                            value: 2
                        },
                        symbolSize: 10,
                        showEffectOn: 'render',
                        rippleEffect: {
                            period: 4,
                            scale: 3,
                            brushType: 'fill'
                        },
                        hoverAnimation: true,
                        label: {
                            formatter: '{b}',
                            position: 'right',
                            show: true,
                            backgroundColor: 'rgba(2, 31, 95, 0.82)',
                            borderColor: '#85A9DF',
                            borderWidth: 1,
                            borderRadius: 5,
                            padding: 10,
                        },
                        itemStyle: {
                            color: function(params){
                                if(params.data.meterStatus !== '正常') {
                                    return 'red'
                                }
                                return '#00FAFE'
                            } ,
                            shadowBlur: 10,
                            shadowColor: '#333'
                        },
                        zlevel: 1
                    }
                ]
            }
            setTimeout(()=> {
                //echarts.registerMap('shanxi', sxmap);
                that.chart.setOption(option)
                that.bmap = that.chart.getModel().getComponent('bmap').getBMap()
                that.bmap.setMinZoom(6) // 设置地图最小缩放比例
                that.bmap.setMaxZoom(12) // 设置地图最大缩放比例
                that.bmap.setMapStyleV2({styleJson:this.customMapStyle});
                var bd = new BMapGL.Boundary();
                bd.get(city, function (rs) {
                    var count = rs.boundaries.length; //行政区域的点有多少个
                    var pointArray = [];
                    for (var i = 0; i < count; i++) {
                        var path = [];
                        let str = rs.boundaries[i].replace(' ', '');
                        let points = str.split(';');
                        for (var j = 0; j < points.length; j++) {
                            var lng = points[j].split(',')[0];
                            var lat = points[j].split(',')[1];
                            path.push(new BMapGL.Point(lng, lat));
                        }
                        var prism = new BMapGL.Prism(path, 5000, {
                            topFillColor: '#5679ea',
                            topFillOpacity: 0.5,
                            sideFillColor: '#5679ea',
                            sideFillOpacity: 0.9

                        });
                        that.bmap.addOverlay(prism);
                    }
                });
                that.bmap.setTilt(30);
                that.chart.on('click',function(params){
                    console.log(params)
                    for(let i =0;i<data.length;i++) {
                        if(1==1) {
                            break;
                        }
                    }
                    var point = new BMapGL.Point(params.value[0],params.value[1]);
                    var opts = {
                        width : 500,     // 信息窗口宽度
                        height: 200,     // 信息窗口高度
                        title : that.$t('设备详情') , // 信息窗口标题
                        message: that.$t('设备详情信息')
                    }
                    let str = '<div><table border="1">'
                       str+='<tr><th>'+that.$t('设备编号')+'</th><th>'+that.$t('用户姓名')+'</th><th>'+that.$t('联系电话')+'</th><th>'+that.$t('安装位置')+'</th><th>'+that.$t('阀门状态')+'</th><th>'+that.$t('运行状态')+'</th></tr>'
                       getAction(that.url.queryMetersByPointer, {lng: params.value[0],lat: params.value[1]}).then((res) => {
                           if(res.success&&res.result.length>0) {
                               for(let i =0;i<res.result.length;i++) {
                                   let data = res.result[i]
                                   let status = that.$t('正常')
                                   if(data.meterBatteryStatus!==0) {
                                       status = that.$t('欠压')
                                   }
                                   if(data.meterBatteryStatus!==0) {
                                       status+=that.$t('有磁干扰')
                                   }
                                   let valveStatusObj = {0: that.$t('关阀'),1: that.$t('开阀')}
                                    str+=`<tr><td>${data.meterId}</td><td>${data.userName}</td><td>${data.userPhone}</td><td>${data.userMeterAddr}</td><td>${valveStatusObj[data.meterValveStatus]}</td><td>${status}</td>`
                                    str+=`</tr>`
                               }
                           }
                           str+='</table></div>'
                           console.log(str)
                           var infoWindow = new BMapGL.InfoWindow(str, opts);  // 创建信息窗口对象 
                            that.bmap.openInfoWindow(infoWindow, point); //开启信息窗口
                            console.log("信息弹窗打开完毕")
                       })
                       return 'loading'
                })
            },800)
        }
    },
    beforeDestroy() {
    }
}
</script>
<style>
.BMap_bubble_pop{
    background-color: rgba(2,31,95,0.85) !important;
    border: 1px solid #00FAFE !important;
    
}
.BMap_bubble_pop .BMap_bubble_content,.BMap_bubble_pop .BMap_bubble_title {
    color: #85A9DF !important;
}
</style>